;(function($, window, document){
    window.NavDropdown = Me.view.extend({
        options: {
            urlToRedirect: null
        },

        initialize: function() {
            _.bindAll(this, 'openDropdownTab', 'hideDropdownTab');
            this.addEvents();

        },
        addEvents: function() {
            this.$el.on('click', this.openDropdownTab);
        
      
            
        },
        openDropdownTab: function (e) {
            var view = this;
            var currencyBtn = $(e.currentTarget);
            currencyBtn.toggleClass('open');

            var totalHeight = 0;

            if (currencyBtn.hasClass('open')){
                currencyBtn.children('.nav-dropdown-changer').children().each(function (index, value) {
                    totalHeight += parseInt($(value).outerHeight(true));
                });
                currencyBtn.children('.nav-dropdown-changer').height(totalHeight);
                setTimeout(function(){
                    $('body').on('click', view.hideDropdownTab);
                },0);
            }
            else {
                currencyBtn.children('.nav-dropdown-changer').height('0px');

                $('body').off('click', view.hideDropdownTab);
            }
        },
        hideDropdownTab: function (e) {
            if(e){
                if($(e.target).hasClass('nav-dropdown-ctn') || $(e.target).parents('.nav-dropdown-ctn').length != 0){
                    return;
                }
            }

            $('body').off('click', this.hideDropdownTab);

            this.$('.nav-dropdown-changer').height('0px');
            this.$el.removeClass('open');
        }
    });
}(jQuery, window, document));
